// extracted by mini-css-extract-plugin
export default {"root":"Comparables__root--SGRyA"};